
import React, { Component } from "react";
import moment from 'moment';
import { withStyles, Grid, Fade, CircularProgress, Typography, TableBody, Table, TableRow, Card, CardContent, Divider, Icon, Tooltip, IconButton } from "@material-ui/core";
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import Paper from '@material-ui/core/Paper';
import { Color, STATES } from "../Constants";
import { makeStyles } from "@material-ui/core/styles";
import { DeliveryService } from "../Services/DeliveryService";
import { getTimeInIST, format_fancy, formatNumber, format_date_only, StyledTableCell, format } from "../Utils";
import clsx from "clsx";
import EnhancedTableHead from "../components/EnhancedTableHead";
import ItemSelection from "../components/ItemSelection";
import { blue } from "@material-ui/core/colors";

const styles = theme =>({
    fab: {
        margin: theme.spacing(1),
    },
    root: {
      width: '100%',
      marginTop: theme.spacing(3)
    },
    StyledTableCell: {
        fontSize: '30pt',
        padding: 2
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        width: "80%",
        outline: 'none',
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginBottom : '20px',
    },
    formControl: {
        margin: theme.spacing(1),
        marginTop: theme.spacing(1),
        // minWidth: 200,
        marginLeft: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(1),
        },
        float: 'left'
    },
    section: {
		width: '100%',
		minHeight: 400,
		overflow: 'auto',
		overflowX: 'auto',
		paddingTop : theme.spacing(1), 
		paddingLeft: theme.spacing(1), 
		paddingRight: theme.spacing(1),
		paddingBottom: theme.spacing(1)
    },
    table: {
        height: 300,
        overflow: 'auto'
    }, 
    selectRoot: {
        [theme.breakpoints.down('md')]: {
            marginLeft: 0,
            marginRight: 0
        },
    },
    heading: {
        fontSize: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightRegular,
    },
    card: {
        minWidth: 300,
    },
  });

class StoreDeliveryStatus extends Component {

    constructor(props) {
      super(props);
      this.state = {       
        schedule_date: moment(),
        showSpinner: false,
        attempted_rows: [],
        unattended_rows: [],
        agents: [],
        selected_agent: "-1",
        total_amount: 0,
        total_return_amount: 0,
        data: [],
        agent_rows: [],
        columns : [
            { id: 'sl_no', align: 'left', numeric: false, disablePadding: false, label: 'Sl.no', sortable: false  },
            { id: 'store_name', align: 'left', numeric: false, disablePadding: false, label: 'Store', sortable: false  },
            { id: 'state', align: 'left', numeric: false, disablePadding: false, label: 'State', sortable: false  },
            { id: 'agent_name', align: 'left', numeric: false, disablePadding: false, label: 'Agent', sortable: false  },
            { id: 'route_id', align: 'left', numeric: true, disablePadding: false, label: 'Route', sortable: false  },
            { id: 'delivery_date', align: 'left', numeric: false, disablePadding: false, label: 'Delivery Date', sortable: false  },
            { id: 'total_amount', align: 'right', numeric: true, disablePadding: false, label: 'Billed', sortable: false  },
            { id: 'total_return_amount', align: 'right', numeric: true, disablePadding: false, label: 'Returned', sortable: false  },
            { id: 'invoice_no', align: 'left', numeric: false, disablePadding: false, label: 'Invoice No', sortable: false  },
            { id: 'credit_note_no', align: 'left', numeric: false, disablePadding: false, label: 'Credit Note No', sortable: false  },
            { id: 'reason', align: 'left', numeric: false, disablePadding: false, label: 'Reason', sortable: false  },
            { id: 'away', align: 'left', numeric: false, disablePadding: false, label: 'Delivered at Store', sortable: false  },
            { id: 'actions', numeric: false, disablePadding: false, label: '', sortable: false  },
        ],
        order: 'asc',
        orderBy: 'store_name',
        columns_unattempted : [
            { id: 'sl_no', align: 'left', numeric: false, disablePadding: false, label: 'Sl.no', sortable: false  },
            { id: 'store_name', align: 'left', numeric: false, disablePadding: false, label: 'Store', sortable: false  },
            { id: 'state', align: 'left', numeric: false, disablePadding: false, label: 'State', sortable: false  },
            { id: 'agent_name', align: 'left', numeric: false, disablePadding: false, label: 'Agent', sortable: false  },
            { id: 'route_id', align: 'left', numeric: false, disablePadding: false, label: 'Route', sortable: false  },
            { id: 'actions', numeric: false, disablePadding: false, label: '', sortable: false  }
        ],
        order_unattempted: 'asc',
        orderBy_unattempted: 'store_name',
        states: [],
        selectedState: null,
      }
    }

    componentDidMount(){
        this.props.setTitle('Daily Delivery Status');
        window.addEventListener("focus", this.fetchData);
        this.setState({showSpinner: true}, () => this.fetchData());
    }

    componentWillUnmount() {
        window.removeEventListener("focus", this.fetchData);
    }

    handleChangeScheduleDate = (date) => {
        if(date !== this.state.schedule_date){
            this.setState({
                schedule_date: date,
            }, () => this.fetchData());
        }
    }

    export = () => {
        const {schedule_date} = this.state;
        this.props.isLoading(true);
        let filename = `Daily Delivery Report ${schedule_date.format(format_date_only)}}.xlsx`;
        DeliveryService.getDailyDeliveryReport(schedule_date, schedule_date)
        .then(response => {
            return response.blob()
        })
        .then((blob) => {
            this.props.isLoading(false);
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            // 3. Append to html page
            document.body.appendChild(link);
            // 4. Force download
            link.click();
            // 5. Clean up and remove the link
            link.parentNode.removeChild(link);
        })
        .catch(error => {
            this.props.isLoading(false);
            console.log(error);
        });
    }

    onClick = (state) => {
        this.props.history.push(`/report/delivery/statewise?state=${state}&startdate=${moment(this.state.schedule_date).format(format)}&enddate=${moment(this.state.schedule_date).format(format)}`);
    }

    fetchData = () => {
        let {schedule_date} = this.state;
        this.setState({showSpinner: true});
        let attempted_list = [], unattended_list = [];
        this.props.showProgressDialog();
        DeliveryService.getStoreDeliveryStatus(schedule_date)
        .then((data) => {
            // console.log(data);
            let total_amount = 0;
            let total_return_amount = 0;
            let agents = [], agent_rows = [];
            if(data && data.length > 0){
                attempted_list = data.filter(s => s.delivery_date !== null);
                unattended_list = data.filter(s => s.delivered_status === null && s.delivery_date === null && s.reason === null);

                total_amount = attempted_list.reduce(function(accumulator, currentValue) {
                    return accumulator + parseFloat(currentValue.total_amount);
                }, total_amount);
                // console.log(total_amount);
                
                total_return_amount = attempted_list.reduce(function(accumulator, currentValue) {
                    return accumulator + parseFloat(currentValue.total_return_amount);
                }, total_return_amount);
                // console.log(total_return_amount);

                let aList = new Set(data.map(r => r.agent_name));
                // console.log(aList);
                aList.forEach(a => {
                    agents.push({
                        id: a,
                        value: a, 
                        label: a
                    });

                    let a_attempted_list = attempted_list.filter(s => s.agent_name === a);

                    let pending = unattended_list.filter(s => s.agent_name === a).length;
                    let completed = a_attempted_list.length;

                    let a_total_amount = 0;
                    a_total_amount = a_attempted_list.reduce(function(accumulator, currentValue) {
                        return accumulator + parseFloat(currentValue.total_amount);
                    }, a_total_amount);

                    let a_expected_amount = 0;
                    a_expected_amount = data.filter(s => s.agent_name === a).reduce(function(accumulator, currentValue) {
                        return accumulator + parseFloat(currentValue.expected_amount);
                    }, a_expected_amount);

                    let a_total_return_amount = a_attempted_list.reduce((sum, next) => sum + parseFloat((next.total_return_amount) || 0), 0);

                    // let a_revenue_lost = a_expected_amount - a_total_amount;

                    agent_rows.push(
                        <Grid item container key={a}>
                            <Grid item xs={4} lg={2}>
                                <Typography color="textPrimary" variant="button" style={{fontWeight: 'bolder'}} gutterBottom align="justify">
                                    {a}
                                </Typography>
                            </Grid>
                            <Grid item xs={4} lg={2}>
                                <Typography color="primary"  gutterBottom align="right">
                                    {completed}
                                </Typography>
                            </Grid>
                            <Grid item xs={4} lg={2}>
                                <Typography color="secondary"  gutterBottom align="right">
                                    {pending}
                                </Typography>
                            </Grid>
                            <Grid item xs={4} lg={2}>
                                <Typography gutterBottom align="right">
                                    {formatNumber(a_expected_amount)}
                                </Typography>
                            </Grid>
                            <Grid item xs={4} lg={2}>
                                <Typography color="primary"  gutterBottom align="right">
                                    {formatNumber(a_total_amount)}
                                </Typography>
                            </Grid>
                            <Grid item xs={4} lg={2}>
                                <Typography color={a_total_return_amount <= 0 ? "primary" : "secondary"}  gutterBottom align="right">
                                    {formatNumber(a_total_return_amount <= 0 ? 0 : a_total_return_amount)}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} lg={12}>
                                <Divider variant="fullWidth"/>
                            </Grid>
                        </Grid>);
                });

            }

            agents.unshift({
                id: '-1',
                value: '-1', 
                label: 'ALL'
            });

            this.setState({showSpinner: false, agent_rows, data, total_amount, agents, total_return_amount}, () => this.refresh());
            this.props.closeProgressDialog();
        })
        .catch(error => {
            console.log(error);
            this.setState({showSpinner: false, message: "Failed to fetch details. Check internet connection and retry."});
            this.props.closeProgressDialog();
        });
    }

    refresh = () => {
        let {data, selected_agent, order, orderBy, order_unattempted, orderBy_unattempted} = this.state;
        let attempted_rows = [], unattended_rows = [], attempted_list = [],  unattended_list = [];
        if(selected_agent !== '-1'){
            data = data.filter(d => d.agent_name === selected_agent);
        }

        unattended_list = data.filter(s => s.delivered_status === null && s.delivery_date === null && s.reason === null);
        attempted_list = data.filter(s => s.delivery_date !== null);

        // Sorting
        if(order === 'asc'){
		    attempted_list.sort((a, b) => (a[orderBy] > b[orderBy]) ? 1 : -1);
		} else {
		    attempted_list.sort((a, b) => (a[orderBy] < b[orderBy]) ? 1 : -1);
        }
        
        // Sorting Unattempted
        if(order_unattempted === 'asc'){
		    unattended_list.sort((a, b) => (a[orderBy_unattempted] > b[orderBy_unattempted]) ? 1 : -1);
		} else {
		    unattended_list.sort((a, b) => (a[orderBy_unattempted] < b[orderBy_unattempted]) ? 1 : -1);
		}
        unattended_list.forEach((store, index) => {
            unattended_rows.push(<StoreDetailsUnattended index={index + 1} key={store.transaction_id} store={store} onClick={this.onClick}/>);
        });
        attempted_list.forEach((store, index) => {
            attempted_rows.push(<StoreDetailsAttempted index={index + 1} key={store.transaction_id} store={store} onClick={this.onClick}/>);
        });

        this.setState({showSpinner: false, unattended_rows, attempted_rows});

    }

    // handleAgentSelection = (e) => {
    //     this.setState({selected_agent: e.value}, () => this.refresh());
    // }
    handleAgentSelection = (agent) => {

        this.setState({selected_agent: agent.value}, () => this.refresh());
    }

    sortBy = (event, property) => {
        // const orderBy = property;
        // let order = 'desc';
        
        let {orderBy, order} = this.state;

		if (orderBy === property && order === 'desc') {
		    order = 'asc';
		} else {
            order = 'desc';
        }

        // let items = attempted_list;
        orderBy = property;

		this.setState({ order, orderBy}, () => {
				this.refresh();
		});
    }

    sortByUnattempted = (event, property) => {
        // const orderBy = property;
        // let order = 'desc';
        
        let {orderBy_unattempted, order_unattempted} = this.state;

		if (orderBy_unattempted === property && order_unattempted === 'desc') {
		    order_unattempted = 'asc';
		} else {
            order_unattempted = 'desc';
        }

        // let items = attempted_list;
        orderBy_unattempted = property;

		this.setState({ order_unattempted, orderBy_unattempted}, () => {
				this.refresh();
		});
    }
    
    render() {
        let { columns, columns_unattempted, schedule_date, agents, agent_rows, selected_agent, showSpinner, unattended_rows, attempted_rows, total_amount, total_return_amount} = this.state;
        const { classes } = this.props;
        return ( 
            <div className="Home" style={{marginTop: 25}}>
                    <Grid container spacing={2}>
                        <Grid container item xs={12} lg={4}>
                            <Grid item xs={12} lg={12}>
                                <Card className={classes.card}>
                                    <CardContent>
                                        <Grid container spacing={0}>
                                            <Grid item xs={8} lg={4}>
                                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                                    <DatePicker
                                                        variant="dialog"
                                                        margin="dense"
                                                        label="Schedule Date"
                                                        value={schedule_date}
                                                        onChange={this.handleChangeScheduleDate}
                                                        format='DD MMM YYYY'
                                                        maxDate={moment()}
                                                        inputVariant="outlined"
                                                        invalidDateMessage=""
                                                        fullWidth
                                                        style={{marginTop: 16}}
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </Grid>
                                            <Grid item xs={12} lg={6}>
                                                <ItemSelection 
                                                    required 
                                                    margin="dense"
                                                    label='Agent' 
                                                    value={agents.filter((action) => action.value === selected_agent)[0] || null} 
                                                    optionLabel='label' 
                                                    options={agents.filter(a => a != null)} 
                                                    selected={(agent) => this.handleAgentSelection(agent)}/>
                                                {/* <FormControl variant="outlined" className={classes.formControl}>
                                                    <AutoCompleteSelection 
                                                        margin="dense" 
                                                        placeHolder="Agent"
                                                        isMulti={false}
                                                        onChange={this.handleAgentSelection}
                                                        value={agents.filter((action) => action.value === selected_agent)}
                                                        className={classes.textField}
                                                        required={true}
                                                        options={agents}/>
                                                </FormControl> */}
                                            </Grid>
                                            <Grid item>
                                                <Tooltip title="Download Report">
                                                    {/* <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={(e) => this.export()}
                                                        style={{marginTop: 10}}
                                                        endIcon={<Icon>save_alt</Icon>}
                                                    >
                                                    Download
                                                    </Button> */}
                                                    <IconButton style={{marginTop: 10}} variant="" onClick={(e) => this.export()}>
                                                        <Icon>save_alt</Icon>
                                                    </IconButton>
                                                </Tooltip>
                                            </Grid>
                                            <Grid item xs={6} lg={6}>
                                                <Typography className={classes.title} color="textPrimary"  gutterBottom align="justify">
                                                    Total Revenue
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6} lg={6}>
                                                <Typography className={classes.title} color="primary"  gutterBottom align="right">
                                                    {formatNumber(total_amount)}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6} lg={6}>
                                            <Typography className={classes.title} color="textPrimary"  gutterBottom align="justify">
                                                    Total Returns 
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6} lg={6}>
                                                <Typography className={classes.title} color="secondary"  gutterBottom align="right">
                                                    {formatNumber(total_return_amount)}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} lg={8}>
                            <Card className={classes.card}>
                                <CardContent>
                                    <Grid container spacing={0}>
                                        <Grid item xs={4} lg={2}>
                                            <Typography color="textPrimary" variant="body1" className={classes.title} style={{fontWeight: "bolder"}} gutterBottom align="justify">
                                                Agent
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4} lg={2}>
                                            <Typography color="primary" variant="body1" className={classes.title} style={{fontWeight: "bolder"}} gutterBottom align="right">
                                                Attempted
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4} lg={2}>
                                            <Typography color="secondary" variant="body1" className={classes.title} style={{fontWeight: "bolder"}} gutterBottom align="right">
                                                Unattempted
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4} lg={2}>
                                            <Typography variant="body1" className={classes.title} style={{fontWeight: "bolder"}} gutterBottom align="right">
                                                Expected
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4} lg={2}>
                                            <Typography color="primary" variant="body1" className={classes.title} style={{fontWeight: "bolder"}} gutterBottom align="right">
                                                Billed
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4} lg={2}>
                                            <Typography color="secondary" variant="body1" className={classes.title} style={{fontWeight: "bolder"}} gutterBottom align="right">
                                                Returns
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} lg={12}>
                                            <Divider variant="fullWidth"/>
                                        </Grid>
                                        {agent_rows}
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item container xs={12} lg={12} md={12}>
                            <Paper className={classes.root} style={{marginTop: 10, padding: 10}}>
                                <Typography variant="h6" style={{textAlign: "center", margin: 20}}>
                                    Unattempted Stores ({unattended_rows.length})
                                </Typography>
                                <div style={{marginTop: '10px', maxHeight: 500, overflowY: "auto"}}>
                                    <Table stickyHeader size="small">
                                        <EnhancedTableHead
                                            order={this.state.order_unattempted}
                                            orderBy={this.state.orderBy_unattempted}
                                            onRequestSort={this.sortByUnattempted}
                                            rows ={columns_unattempted} />
                                        {/* <TableHead>
                                            <TableRow>
                                                <StyledTableCell style={{zIndex: 0}}>Sl.no</StyledTableCell>
                                                <StyledTableCell style={{zIndex: 0}}>Store</StyledTableCell>
                                                <StyledTableCell style={{zIndex: 0}}>Agent</StyledTableCell>
                                                <StyledTableCell style={{zIndex: 0}}>Route</StyledTableCell>
                                                <StyledTableCell style={{zIndex: 0}}></StyledTableCell>
                                            </TableRow>
                                        </TableHead> */}
                                        { unattended_rows.length !== 0 ?
                                            <TableBody style={{textAlign: "left"}}>
                                                {unattended_rows}
                                            </TableBody>
                                            :
                                            <TableBody>
                                                <TableRow>
                                                    <StyledTableCell colSpan={5} align="center">No Stores Pending</StyledTableCell>
                                                </TableRow>
                                            </TableBody>
                                            
                                        }
                                    </Table>
                                </div>
                            </Paper>
                        </Grid>
                        <Grid item container xs={12} lg={12} md={12}>
                            <Paper className={classes.root} style={{marginTop: 10, padding: 10}}>
                                <Typography variant="h6" style={{textAlign: "center", margin: 20}}>
                                    Attempted Stores ({attempted_rows.length})
                                </Typography>
                                <div style={{marginTop: '10px', maxHeight: 500, overflowY: "auto"}}>
                                    <Table stickyHeader size="small">
                                        <EnhancedTableHead
                                            order={this.state.order}
                                            orderBy={this.state.orderBy}
                                            onRequestSort={this.sortBy}
                                            rows={columns} />
                                        {/* <TableHead>
                                            <TableRow>
                                                <StyledTableCell>Sl.no</StyledTableCell>
                                                <StyledTableCell>Store</StyledTableCell>
                                                <StyledTableCell>Agent</StyledTableCell>
                                                <StyledTableCell>Route</StyledTableCell>
                                                <StyledTableCell>Delivery Date</StyledTableCell>
                                                <StyledTableCell>Invoice No</StyledTableCell>
                                                <StyledTableCell>Credit Note No</StyledTableCell>
                                                <StyledTableCell>Reason</StyledTableCell>
                                                <StyledTableCell>Delivered at Store</StyledTableCell>
                                                <StyledTableCell></StyledTableCell>
                                            </TableRow>
                                        </TableHead> */}
                                        { attempted_rows.length !== 0 ?
                                            <TableBody style={{textAlign: "left"}}>
                                                {attempted_rows}
                                            </TableBody>
                                            :
                                            <TableBody>
                                                <TableRow>
                                                    <StyledTableCell colSpan={5} align="center">No Stores Attempted</StyledTableCell>
                                                </TableRow>
                                            </TableBody>
                                            
                                        }
                                    </Table>
                                </div>
                            </Paper>
                        </Grid>
                    </Grid>
                    <Fade
                        key="spinner"
                        in={showSpinner}
                        style={{
                            transitionDelay: showSpinner ? '10ms' : '0ms',
                            position: 'absolute', left: '50%', top: '60%'
                        }}
                        unmountOnExit
                        >
                        <CircularProgress style={{marginTop: 20, color: Color.green}} color="inherit" size={60}/>
                    </Fade>
               
            </div>
        );
    }
}

const useStyles = makeStyles(theme => ({
    heading: {
        fontSize: theme.typography.pxToRem(16),
        fontWeight: theme.typography.fontWeightMedium,
        textAlign: 'left'
    },
    subheading: {
        fontSize: theme.typography.pxToRem(16),
        textAlign: 'left'
    },
    grid:{
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        paddingBottom: theme.spacing(2),
    },
    large: {
        width: 150,
        textAlign: 'left'
    },
    xlarge: {
        width: 200,
        textAlign: 'left'
    },
    StyledTableCellAction: {
        fontSize: '10pt',
        padding: 2,
        color: 'blue',
        cursor: 'pointer',
        textAlign: 'left'
    },
    red: {
        color: 'red'
    },
    grey: {
        color: 'grey'
    },
    black: {
        color: 'black'
    }
}));

function StoreDetailsUnattended(props){

    const {store, index} = props;
    
    // const classes = useStyles();
    
    return (
        <TableRow>
            <StyledTableCell>{index}</StyledTableCell>
            <StyledTableCell>{store.store_name}</StyledTableCell>
            <StyledTableCell onClick={() => props.onClick(store.state)} style={{cursor: 'pointer', color: blue[500]}}>
                {store.state ? STATES.find(s => s.code === store.state).name : "-"}
            </StyledTableCell>
            <StyledTableCell>{store.agent_name}</StyledTableCell>
            <StyledTableCell>{store.route_id}</StyledTableCell>
            <StyledTableCell></StyledTableCell>
        </TableRow>
    );
}

function StoreDetailsAttempted(props){

    const {store, index} = props;

    store.away = parseFloat(store.away);
    
    const classes = useStyles();

    function openLink(link){
        if(link.length > 0){
            window.open(link, "_blank")
        }
    }                                 
    
    return (
        <TableRow>
            <StyledTableCell>{index}</StyledTableCell>
            <StyledTableCell>{store.store_name}</StyledTableCell>
            <StyledTableCell onClick={() => props.onClick(store.state)} style={{cursor: 'pointer', color: blue[500]}}>
                {store.state ? STATES.find(s => s.code === store.state).name : "-"}
            </StyledTableCell>
            <StyledTableCell>{store.agent_name}</StyledTableCell>
            <StyledTableCell className={classes.xlarge}>{store.route_id}</StyledTableCell>
            <StyledTableCell className={classes.xlarge}>{getTimeInIST(store.delivery_date).format(format_fancy)}</StyledTableCell>
            <StyledTableCell align="right">{formatNumber(store.total_amount)}</StyledTableCell>
            <StyledTableCell align="right">{store.total_return_amount <= 0 ? '-' : formatNumber(store.total_return_amount)}</StyledTableCell>
            <StyledTableCell className={store.invoice_url ? clsx(classes.large, classes.StyledTableCellAction) : classes.large} onClick={() => store.invoice_url ? openLink(store.invoice_url) : undefined }>{store.invoice_no ? store.invoice_no : "-"}</StyledTableCell>
            <StyledTableCell className={store.credit_note_url ?  clsx(classes.large, classes.StyledTableCellAction) : classes.large} onClick={() => store.credit_note_url ? openLink(store.credit_note_url) : undefined }>{store.credit_note_no ? store.credit_note_no : "-"}</StyledTableCell>
            <StyledTableCell className={classes.large}>{store.reason ? (store.delivered_status ? "-" : store.reason) : "-"}</StyledTableCell>
            <StyledTableCell padding="none" className={store.away > 0 ? ( store.away < 250 ? classes.black : classes.red ) : classes.grey }>{store.away > 0 ? ( store.away < 250 ? "Yes" : "No") : "Not available"}</StyledTableCell>
            <StyledTableCell></StyledTableCell>
        </TableRow>
    );
}

export default withStyles(styles)(StoreDeliveryStatus);